import { isFunction } from 'lodash-es'
import React from 'react'
import { Formik, type FormikValues } from 'formik'

import { TtForm } from '@23/react'

import type { FormikFormProps } from './index'

const TtFormFormik = <FormValues extends FormikValues>({
  initialStatus,
  initialValues,
  initialTouched,
  initialErrors,
  isInitialValid,
  enableReinitialize,
  onSubmit,
  onReset,
  validate,
  validationSchema,
  validateOnBlur,
  validateOnChange,
  validateOnMount,
  novalidate,
  innerRef,
  children,
  ...props
}: FormikFormProps<FormValues>) => {
  return (
    <Formik
      initialStatus={initialStatus}
      initialValues={initialValues}
      initialTouched={initialTouched}
      initialErrors={initialErrors}
      isInitialValid={isInitialValid}
      enableReinitialize={enableReinitialize}
      onSubmit={onSubmit}
      onReset={onReset}
      validate={validate}
      validationSchema={validationSchema}
      validateOnBlur={validateOnBlur ?? true}
      validateOnChange={validateOnChange ?? false}
      validateOnMount={validateOnMount ?? false}
      innerRef={innerRef}
    >
      {(formik) => {
        return (
          <TtForm
            // ref={ref} // TODO: find a way to forward ref this and keep the generic type
            novalidate={novalidate ?? !!(validationSchema || validate)}
            {...props}
            onTt-submit={(e) => {
              if (e.target === e.currentTarget) {
                formik.handleSubmit()
              }
            }}
          >
            {isFunction(children) ? children(formik) : children}
          </TtForm>
        )
      }}
    </Formik>
  )
}

export { TtFormFormik }
